import { Component, type ErrorInfo, type ReactNode } from "react";
import { Button } from "./button.js";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

/**
 * ErrorBoundary — captura errores de render en todo el árbol y muestra una
 * pantalla amigable en vez de un white screen. Errores async (fetch) se manejan
 * en cada feature con friendlyMessage(); esto es la red de seguridad final.
 */
export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error("[ErrorBoundary]", error, info.componentStack);
  }

  private handleReload = (): void => {
    window.location.reload();
  };

  render(): ReactNode {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="grid min-h-screen place-items-center bg-secondary px-4">
        <div className="w-full max-w-sm rounded-lg border bg-card p-6 text-center shadow-sm">
          <h1 className="text-lg font-semibold text-foreground">Algo salió mal</h1>
          <p className="mt-2 text-sm text-muted-foreground">
            Tuvimos un problema inesperado. Prueba recargar la página; si sigue pasando, avisa al
            administrador.
          </p>
          <Button className="mt-4 w-full" onClick={this.handleReload}>
            Recargar
          </Button>
        </div>
      </div>
    );
  }
}
